export default __webpack_public_path__ + "static/image9-4001480a39f59959f45b3c63ccb21f04.gif";